enum LocalStorageKey {
  ColorMode = "ColorMode",
}

export default LocalStorageKey;
